import { FC, ReactNode, useMemo } from "react";

import {
  StrapiImageFormatSizeI,
  StrapiImageI,
} from "@/interfaces/strapi/image";
import { postImgUrl } from "@/helpers/post";
import { useDynamicImage } from "shared/lib/hooks/use-dynamic-image";
import { clsxMerge } from "shared/lib/helpers";

interface StrapiImagePropsI {
  className?: string;
  image: StrapiImageI;
  fallback?: ReactNode;
  format?: StrapiImageFormatSizeI;
}

export const StrapiImage: FC<StrapiImagePropsI> = ({
  className,
  image,
  fallback,
  format = "medium",
}) => {
  const imageToDisplay = useMemo(
    () => image?.data?.attributes?.formats?.[format] || image?.data?.attributes,
    [image]
  );

  const { imageClassName, src } = useDynamicImage(
    postImgUrl(imageToDisplay?.url) as string
  );

  if (!imageToDisplay) {
    return fallback || null;
  }

  return (
    <img
      alt={image?.data?.attributes.caption}
      loading="lazy"
      className={clsxMerge(imageClassName, className)}
      src={src}
    />
  );
};
